import { Container, Row, Col, Card, Table } from 'react-bootstrap';
import './Common.scss';

export default function Staff() {
  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <h1 className="display-4 mb-4 text-success">施術者紹介</h1>
              <h2 className="h3 text-muted mb-4">
                ヒーリングサロンGundariの施術者をご紹介します。
              </h2>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6} md={6} sm={12} xs={12} className="mt-4 d-flex">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <img
                src={require('../../images/staff_introduction_owner.jpeg')}
                alt="画像は開発中のものです"
                className="img-fluid"
              />
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6} md={6} sm={12} xs={12} className="mt-4 d-flex">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <h2 className="h3 text-muted mb-4">
                ドラゴニックシャーマンクンダリーニ
              </h2>
              <p className="lead">
                MMS公認ヒーラー。シャーマン。ただし霊感の精度はまだ発展途上。ヒーリング歴1年。ヒーリングサロンGundariのオーナー。魔法使い(ネットスラング的な意味で)。もうすぐ妖精に進化だ、わーい。
              </p>
              <p className="lead">
                好きな言葉は「人前で恥ずかしいことできるからイプシスマス(最高位の魔術師)になれるんだ」(MMS
                JAPAN校長ソヴリン・イプシスマス中込英人さんのヒーラーズアカデミー1の形而上学講義での言葉で、今の私のバイブルです)。
              </p>
              <p className="lead">
                この言葉って何気ないジョークのように聞こえますが、物質的豊かさや精神的豊かさどちらを追い求める際にも重要な要素だと思います。なぜなら、他者の目を気にして自分の願いや欲求を抑圧し続けると、いずれ自分が何をしたいのか、何を求めているのかがわからなくなり、人生の目的を見失うことになるからです。自分の願いや欲求に正直になり、それを表現することは、自分らしい人生を築くために不可欠です。たとえそれが他者から見て恥ずかしいことであっても、自分の内なる声に従うことが最終的には自己実現と幸福につながると信じています。人の目を気にしない、だから自分が本当に着たい服を着て食べたいものを食べ会いたい人に会い行きたいところに行けるし、自分の天命や使命に向けて結果に執着しないで動けるから物質的にも精神的にも豊かになれる。このジョークこそが真理だと私は感じました。
              </p>
              <p className="lead">
                2024年MMSヒーラーズアカデミー1で学び、MMS公認ヒーラーのライセンスを習得。
              </p>
              <p className="lead">
                部屋にこもってプログラム書いてるか瞑想してるかの隠遁者。ヒーラーライセンス取得後本来の自分をもっと表現するために白いローブを着て歩き回ってるからか友人達には仙人、僧侶、聖人と呼ばれる。
              </p>
              <p className="lead">
                たまにポケモンGOしながら自然の中を歩いてます。
              </p>
              <p className="lead">
                ヒーラーズアカデミー1で自らの魂・スピリットの側面としてドラゴンの側面があることを知り、ドラゴニックシャーマンのネーミングを考えました。
              </p>
              <p className="lead">
                クンダリーニという名称はサロン名にも設定している軍荼利明王の名前をサンスクリット語にすると「クンダリー(Kundali)」というヒンドゥー教の女神様の名前になりますが、彼女が支配している霊的な力「クンダリーニ(Kundalini)」を示しています。サロン名に合わせて設定しました。
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <h1 className="display-4 mb-4 text-success">オーナーの経歴</h1>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>年</th>
                    <th>経歴</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2015年3月</td>
                    <td>岐阜大学大学院修了、就活失敗して院卒ニート爆誕。</td>
                  </tr>
                  <tr>
                    <td>2015年5月</td>
                    <td>
                      ネトゲ廃人ニートしてメイプルワールドや白猫プロジェクトの世界で魔法使いになってたら親にGLA青年塾にぶち込まれる。そこで投げやりになりながらもワークの中で「癒したい」「導きたい」や「役に立ちたい」などの自らの願いを知る。ただしその時点では何をどうすればいいかわからず、大学で学んだ法律の知識とかけ合わせて他者を癒す行政書士になるとか頓珍漢なことをGLAの仲間の前で宣言してた記憶がある。今思えば自分に素直にならず肉体の自分の知識や価値観だけで物事考えると何も見えなくなる典型例。
                    </td>
                  </tr>
                  <tr>
                    <td>2015年12月</td>
                    <td>
                      ブラック企業に雇われて3年半2交代制工場でブラック労働
                    </td>
                  </tr>
                  <tr>
                    <td>2019年7月</td>
                    <td>うつ病発症して自殺寸前まで行く</td>
                  </tr>
                  <tr>
                    <td>2020年1月</td>
                    <td>
                      療養の過程で小説書きたくなってWeb小説「追放賢者と喪われた巫女」を執筆(後に天界との約束にプロットをそのまま流用して再執筆中)、「癒したい」という願いを思い出して整体やハーブのセラピスト資格取得
                    </td>
                  </tr>
                  <tr>
                    <td>2020年5月</td>
                    <td>
                      執筆していた小説のヒロインをバーチャルの世界に呼び出したくて独学でプログラミング習得。きっかけになったのはYouTubeのプログラミングチャンネルで「VBAできる人はPythonやれ」というフレーズ。工場で働いていた頃から仕事の隙をついて自分の業務を自動化するマクロ組んでたりJavaプログラミング2級取ってたからかPythonがすんなり頭に入った。その他、興味のあった天文物理学の数式(太陽質量ベースのシュバルツシルト半径演算プログラムなど)をプログラミングで実装することやLINE
                      Bot作ってるうちに技術が伸びる。
                    </td>
                  </tr>
                  <tr>
                    <td>2020年8月</td>
                    <td>
                      大好きなクリスタルを見たくて行った名古屋ミネラルショーでhyo-tanさんのブースで見かけたヒーリングワンドに一目惚れ。自らの魂の願いを話したりそれまでの行動を話していたらヒーラーになることを勧められる。
                    </td>
                  </tr>
                  <tr>
                    <td>2021年7月</td>
                    <td>
                      ITフリーランスとして活動開始、スタートアップ企業から仕事もらい始める。
                    </td>
                  </tr>
                  <tr>
                    <td>2022年9月</td>
                    <td>
                      激務とブラック労働からの10徹11連勤でうつ病再発、療養のために仕事を辞める。以後しばらく単発の仕事を受けて日銭を稼ぐか個人開発で作りたいものを作る日々。この頃個人開発で作っていたのはクラスターのワールドやAIキャラクター。あるいはVR領域の研究、ただしVR酔いしやすいため長時間開発できないのがネック。
                    </td>
                  </tr>
                  <tr>
                    <td>2023年3月</td>
                    <td>療養中に民間の心理カウンセラーの資格を取得。</td>
                  </tr>
                  <tr>
                    <td>2023年10月</td>
                    <td>
                      某大手企業より仕事をいただき、ホワイトな労働環境でようやく生活基盤を整えられるようになる。同時期にカナダ在住のサイキックのケイト・キングさんとリモートで面談いただき、自らの魂のルーツを知ったりヒーラーとしての適性(輪廻転生してきた中でのサイキックの使用経験)を教えてもらったりする。以後霊感も少しずつ出始める。
                    </td>
                  </tr>
                  <tr>
                    <td>2024年3月</td>
                    <td>
                      ダイナビジョン株式会社が提供する「本当の自分を知るセッション」にて自らの転生のテーマが「探究」であることや、「子どもたちを守る」という使命を知る。また、転生前には修行僧だったことなども教えてもらう。
                    </td>
                  </tr>
                  <tr>
                    <td>2024年6月</td>
                    <td>
                      GLAで知り合ったKさんを通じてMMSの存在を知る。Kさんの勧めるエンソフィックレイキヒーリング覚えて自分の体にヒーリングかけながら働き続けるとかできたらもっと働けるじゃんという下心満載。エンソフィック受講に際してアデプトプログラム受講必須のためKさんが紹介したMMSガイドの元でアデプトプログラムを受講したところ、お世話になったガイドのあかりさんから最短でリチュアルマスターまで行くように言われ、MMSでの学びを深める。
                    </td>
                  </tr>
                  <tr>
                    <td>2024年10月</td>
                    <td>
                      ヒーラーズアカデミー1を受講し、MMS公認ヒーラーのライセンスを取得。ITエンジニアの片手間でヒーラーとして活動開始。
                    </td>
                  </tr>
                  <tr>
                    <td>2024年12月</td>
                    <td>
                      リチュアルマスター1のプログラムを受講し、聖魔にジョブチェンジ。魔法使いってアニメやゲームみたいに空飛べたり何もないところから火とか水出せるのかと思っていたけどそうでもないことを知りがっかり。光熱費と食費と交通費と医療費を節約するつもりだったのに...。
                    </td>
                  </tr>
                  <tr>
                    <td>2025年5月</td>
                    <td>
                      神聖幾何学2のプログラムを受講し、クリスタルヒーリングを習得。念願だったクリスタルヒーリングの他者への施術ができるようになる。
                    </td>
                  </tr>
                  <tr>
                    <td>2025年6月</td>
                    <td>
                      エンソフィックレイキヒーリング前半プログラムを受講し、エンソフィックレイキヒーリングの施術ができるようになる。
                    </td>
                  </tr>
                  <tr>
                    <td>2025年8月</td>
                    <td>
                      リチュアルマスター2のプログラムを受講し、本当の自分の名前が「軍荼利」であることを知る。なお、名前を教えてもらった時のオーナーの反応は「軍荼利？誰それ？」。プログラム終了後に軍荼利明王のことを調べ、どんな能力持っていたのか、今世の自分の能力と照らし合わせたり性格的な面を見ていくうちに納得する。その際に体験した現象としては自分が軍荼利であると納得した瞬間全身から膨大なエネルギーが湧き出て最低限の睡眠だけで活動できるようになったことである。
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
